import { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import axios from "axios";
import Light from "components/headers/light";
import AnimationRevealPage from "helpers/AnimationRevealPage";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Swal from "sweetalert2";
import { FaEdit, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom"; // Import useNavigate hook
// App.js
import './orders.css';  // Assure-toi que le chemin est correct
import AnnouncementBanner from 'components/AnnouncementBanner';
const Orders = () => {
    const [orders, setOrders] = useState([]);
    const [gainsUser, setGainuser] = useState([]);
    const [salesBonus, setSalesBonnus] = useState([]);
    const [boostBonus, setBoostBonnus] = useState([]);
    const [deviationBonus, setDeviationBonnus] = useState([]);
    const [retraite, setRetraite] = useState([]);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editedOrder, setEditedOrder] = useState({});
    const [approvedAmount, setApprovedAmount] = useState(0);
    const [nonApprovedAmount, setNonApprovedAmount] = useState(0);
    const token = localStorage.getItem("authToken");
    const role = localStorage.getItem("role"); // Assuming role is saved in localStorage
    const navigate = useNavigate(); // Initialize navigate
    useEffect(() => {
        // Check if token exists and user role is valid
        if (!token || role !== "supplier") {
            Swal.fire({
                icon: "error",
                title: "Non autorisé",
                text: "Vous devez être connecté en tant que fournisseur pour accéder à cette page.",
            }).then(() => {
                navigate("/login"); // Redirect to login page
            });
            return;
        }

        fetchAllOrders();
    }, [token, role, navigate])

    const fetchAllOrders = async () => {
    try {
        const token = localStorage.getItem("authToken");
        if (!token) {
            console.error("JWT token not found");
            return;
        }

        const response = await axios.get("https://hbmdijital.online/api/supplier/get-ordersAdmin", { // Fixed the missing quote here
            headers: { Authorization: `Bearer ${token}` }
        });
        if (response.status === 200) {
            setGainuser(response.data.userGain);
            setSalesBonnus(response.data.salesBonus);
            setBoostBonnus(response.data.boostBonus);
            setDeviationBonnus(response.data.deviationBonus);
            setOrders(response.data.orders);
            setRetraite(response.data.retraite);
        } else {
            console.error("Failed to fetch orders:", response.statusText);
        }
    } catch (error) {
        console.error("Error fetching orders:", error);
    }
};
    const gainsPaye = orders
    .filter((order) => order.status === "livré" && order.retraite === 0) // Add the retrait condition here
    .reduce((sum, order) => sum + (order.gain || 0), 0);
    const gainsEnattente = orders
        .filter((order) => order.status !== "livré")
        .reduce((sum, order) => sum + (order.gain || 0), 0);

    const pendingOrders = orders.filter(order => order.status === "en attente").length;
    const completedOrders = orders.filter(order => order.status === "livré").length;
    const cancelledOrders = orders.filter(order => order.status === "annulé").length;
const formattedRevenue = orders.reduce((sum, order) => sum + parseFloat(order.total || 0), 0);
const totalRevenue = parseFloat(formattedRevenue.toFixed(2));
    const gains = gainsUser;
// Ensure each bonus is a valid number before summing
const salesBonus1 = Number(salesBonus) || 0;
const boostBonus1 = Number(boostBonus) || 0;
const deviationBonus1 = Number(deviationBonus) || 0;
const retraites1 = parseFloat(retraite) || 0;

// Calculate the total bonus
const bonusGains1 = salesBonus1 + boostBonus1 + deviationBonus1;
const bonusGains = parseFloat(bonusGains1 .toFixed(2));

// Round to 2 decimal places and convert it to a string
const roundedBonusGains = bonusGains.toFixed(2);

// If you need to use it as a number later:
const roundedBonusGainsNumber = parseFloat(roundedBonusGains);


    const handleEdit = (order) => {
        setSelectedOrder(order);
        setEditedOrder({
            CustomerID: order.customer?.CustomerID || "",
            Name: order.customer?.CustomerName || "",
            Phone: order.customer?.Phone || "",
            Address: order.customer?.Address || "",
            City: order.customer?.City || "",
        });
        setIsEditModalOpen(true);
    };

    const handleDelete = async (orderId) => {
        Swal.fire({
            title: "Êtes-vous sûr?",
            text: "Cette action est irréversible!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Oui, supprimer!",
            cancelButtonText: "Annuler",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const token = localStorage.getItem("authToken");
                    await axios.delete(`https://hbmdijital.online/api/supplier/orders/${orderId}`, {
                        headers: { Authorization: `Bearer ${token}` },
                    });
                    Swal.fire("Supprimé!", "La commande a été supprimée.", "success");
                    fetchAllOrders();
                } catch (error) {
                    console.error("Erreur de suppression:", error);
                    Swal.fire("Erreur", "Impossible de supprimer la commande.", "error");
                }
            }
        });
    };

    const handleSave = async (e) => {
        e.preventDefault();
        if (!selectedOrder) return;

        try {
            await axios.put(
                `https://hbmdijital.online/api/supplier/orders/${selectedOrder.orderId}`,
                editedOrder,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            Swal.fire("Succès", "Commande mise à jour avec succès!", "success");
            fetchAllOrders();
            setIsEditModalOpen(false);
        } catch (error) {
            console.error("Erreur mise à jour:", error);
            Swal.fire("Erreur", "Impossible de modifier la commande.", "error");
        }
    };

    const handleWithdrawRequest = async (gain) => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                Swal.fire({
                    icon: "error",
                    title: "Erreur",
                    text: "JWT token non trouvé dans le stockage local.",
                });
                return;
            }

            const response = await axios.post(
                "https://hbmdijital.online/api/withdraw",
                { roundedBonusGainsNumber },
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.status === 200) {
                Swal.fire({
                    icon: "success",
                    title: "Succès",
                    text: "Votre demande de retrait a été envoyée avec succès.",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Échec",
                    text: "Échec de la demande de retrait.",
                });
            }
        } catch (error) {
            let errorMessage = "Une erreur est survenue lors de la demande de retrait.";
            if (error.response && error.response.data) {
                errorMessage = error.response.data.message || JSON.stringify(error.response.data);
            } else if (error.message) {
                errorMessage = error.message;
            }

            Swal.fire({
                icon: "error",
                title: "Erreur",
                text: errorMessage,
            });
        }
    };

    // Check if the order should be disabled (grayed out)
    const isDisabled = (order) => order.status === "livré" && order.retraite === 1;

    return (
        <AnimationRevealPage>
            <Light />
            <AnnouncementBanner />

            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-between align-items-center gap-2">
                        <h1 className="text-dark display-4">Mon Tableau de Bord</h1>
                        <button 
className="btn" 
style={{ 
    backgroundColor: '#1e3d56', 
    color: 'white', 
    border: 'none', 
    padding: '10px 20px', 
    fontSize: '16px', 
    borderRadius: '5px', 
    fontWeight: 'bold' 
}}                        onClick={() => handleWithdrawRequest(gainsPaye)}>
                            Demander un retrait
                        </button>
                    </div>
                    <hr className="my-4" />

                    {/* Cards Section */}
                    <div className="row g-3 mb-4">
                        {[ 
                            { title: "Commandes en Attente", value: pendingOrders },
                            { title: "Commandes livrées", value: completedOrders },
                            { title: "Commandes Annulées", value: cancelledOrders },
                            { title: "Revenu Total", value: `${totalRevenue} DH` },
                            { title: "Total Gains", value: `${gains} DH` },
                            { title: "Total des bonus gains ", value:  `${roundedBonusGainsNumber} DH` },
                            { title: "Gains sales bonus", value: `${salesBonus} DH` },
                            { title: "Gains boost bonus", value:  `${boostBonus} DH` },
                            { title: "Gains Devotion bonus", value:  `${deviationBonus} DH` },
                            { title: "Total des retraites", value:  `${retraites1} DH` },

                            // { title: "Gains en attente", value: `${gainsEnattente} DH` }
                        ].map((item, index) => (
                            <div className="col-md-4" key={index}>
                               <div className={`card shadow-sm text-white ${[
    "bg-primary",       // Base color
    "bg-primary-500",   // Lighter variant 1
    "bg-primary-400",   // Lighter variant 2
    "bg-primary-300",   // Lighter variant 3
    "bg-primary-200",   // Lighter variant 4
    "bg-primary-100",   // Lighter variant 5
    "bg-info",          // Info color
    "bg-info-500",      // Info lighter variant 1
    "bg-info-400",      // Info lighter variant 2
    "bg-info-300",      // Info lighter variant 3
][index]}`}>


                                    <div className="card-body text-center">
                                        <h5 className="card-title">{item.title}</h5>
                                        <p className="card-text display-6">{item.value}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Orders Table */}
                    <div className="table-responsive">
                        <table className="table table-striped table-bordered">
                            <thead>
                                <tr>
                                    <th>ID Commande</th>
                                    <th>Informations Client</th>
                                    <th>Produits</th>
                                    <th>Statut</th>
                                    <th>Statut de Paiement</th>
                                    <th>Gains</th>
                                    <th>Total</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                          <tbody>
    {orders.map((order) => {
        
        return (
            <tr
                key={order.orderId}
                style={{
                    backgroundColor: isDisabled(order) ? "#f0f0f0" : "",
                    opacity: isDisabled(order) ? 0.6 : 1,
                    pointerEvents: isDisabled(order) ? "none" : "auto",
                }}
            >
                <td>{order.orderId}</td>
                <td>
                    <div>{order.customer?.CustomerName}</div>
                    <div>{order.customer?.Phone}</div>
                    <div>{order.customer?.Address}</div>
                    <div>{order.customer?.City}</div>
                </td>
                <td>{order.productNames?.join(", ")}</td>
                <td>{order.status}</td>
                <td>{order.paymentStatus}</td>
                <td>{order.gain} DH</td>
                <td>{order.total} DH</td>
                <td>
                    <button 
                        className="btn btn-warning me-2" 
                        onClick={() => handleEdit(order)}
                        disabled={order.status === "livr�"} // D�sactive si la commande est livr�e
                    >
                        <FaEdit /> {/* Edit Icon */}
                    </button>
                    
                    <button 
                        className="btn btn-danger" 
                        onClick={() => handleDelete(order.orderId)}
                        disabled={order.status === "livr�"} // D�sactive si la commande est livr�e
                    >
                        <FaTrash /> {/* Delete Icon */}
                    </button>
                </td>
            </tr>
        );
    })}
</tbody>
                        </table>
                    </div>
               {/* Modal for editing */}
               {isEditModalOpen && selectedOrder && (
                    <div className="modal show d-block" id="editModal" tabIndex="-1">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Modifier Commande</h5>
                                    <button type="button" className="btn-close" onClick={() => setIsEditModalOpen(false)}></button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSave}>
                                        <div className="mb-3">
                                            <label htmlFor="customerName" className="form-label">Nom du client</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerName"
                                                value={editedOrder.Name}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, Name: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="customerPhone" className="form-label">Téléphone</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerPhone"
                                                value={editedOrder.Phone}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, Phone: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="customerAddress" className="form-label">Adresse</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerAddress"
                                                value={editedOrder.Address}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, Address: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <div className="mb-3">
                                            <label htmlFor="customerCity" className="form-label">Ville</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="customerCity"
                                                value={editedOrder.City}
                                                onChange={(e) => setEditedOrder({ ...editedOrder, City: e.target.value })}
                                                required
                                            />
                                        </div>
                                        <button type="submit" className="btn btn-primary">Sauvegarder</button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </section>
        </div>
    </AnimationRevealPage>
    );
};

export default Orders;
